import { __ } from '@wordpress/i18n';
import {useState, useEffect } from '@wordpress/element';
import {
    BoxControl,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
} from '@wordpress/components';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';


/**
 * 
* VayuBlocksDimension Component
*
*/

export function VayuBlocksDimensions({
    onChange,
    dimensions={padding:{},margin:{}},
    label={},
    sides= {
        padding: ["top", "bottom", "left", "right"],
        margin: ["top", "bottom", "left", "right"]
      },
    inputProps = {
        padding: { min: 0 },
        margin: { min: -200 }
        },
    splitOnAxis = false,
    short = "",
}) {
    const labelMerge = { panel: 'Dimensions', padding: 'Padding', margin: 'Margin', ...label };

    const {padding,margin} = dimensions;

    const getView = VayuBlocksDevice(); 

    const [firstTablet, setfirstTablet] = useState(false);
    const [firstDesktop, setfirstDesktop] = useState(false);

    const [paddingValues, setPaddingValues] = useState( padding?.value?.[getView] ?? undefined);
    const [marginValues, setMarginValues] = useState(margin?.value?.[getView] ?? undefined);

    useEffect(() => {
        padding?.value && setPaddingValues( padding?.value?.[getView] ?? undefined);

        margin?.value && setMarginValues(margin?.value?.[getView] ?? undefined);

    }, [getView, dimensions]);

    const addPxToIntegers = (values) => {
        return Object.fromEntries(
            Object.entries(values).map(([key, value]) => {
                if (typeof value === 'string' && /^\d+$/.test(value)) {
                    return [key, `${value}px`];  // Convert numeric string to 'px'
                }
                return [key, value];  // Keep other values as they are
            })
        );
    };
    
    const handleDimensionChange = (type, newValue) => {
        
        const updatedValue = addPxToIntegers(newValue);
        const key = dimensions[type].key;
        const attr = dimensions[type].value || {};
        const isFirstRun = attr?.[getView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (getView === 'Desktop') {
            if (isFirstRun || firstDesktop) {

                onChange(key, { Desktop: updatedValue, Tablet: updatedValue, Mobile: updatedValue });
                setfirstTablet(true);
                setfirstDesktop(true);
                localStorage.setItem('firstTablet', true);

            }else{
            // setAttributes({ [key]: { ...attr, Desktop: updatedValue } });
            onChange(key, { ...attr, Desktop: updatedValue });
            }

        } else if (getView === 'Tablet') {

            if (isTabletFirstRun) {
                localStorage.removeItem('firstTablet');
                onChange(key, { ...attr, Tablet: updatedValue, Mobile: updatedValue });
                setfirstTablet(true);
                setfirstDesktop(false);

            }else{
                onChange(key, { ...attr, Tablet: updatedValue });
            }

        } else if (getView === 'Mobile') {
            setfirstTablet(false);
            setfirstDesktop(false);
            onChange(key, { ...attr, Mobile: updatedValue });
        }
   
    }

    const resetAll = () => {
        dimensions?.padding && onChange(dimensions.padding.key, {Desktop:{} , Mobile: {}, Tablet: {}});
        dimensions?.margin && onChange(dimensions.margin.key, {Desktop:{} , Mobile: {}, Tablet: {}});
    }

    const presets = [
        {
            name: '2X-Small',
            slug: '10',
            value: '10px'
          },
          {
            name: '2X-Small',
            slug: '20',
            value: '20px'
          },
        {
          name: 'Small',
          slug: '30',
          value: '30px'
        },
        {
          name: 'Medium',
          slug: '50',
          value: '50px'
        },
        {
          name: 'Large',
          slug: '80',
          value: '80px'
        },
        {
          name: 'X-Large',
          slug: '100',
          value: '100px'
        },
        {
            name: '2X-Large',
            slug: '200',
            value: '200px'
        }
    ]

    return (

        <ToolsPanel className="vayu-blocks-dimesions" resetAll={ resetAll } label={__(labelMerge.panel)}>
            {dimensions.padding && 
                <ToolsPanelItem
                    hasValue={ () => !! paddingValues }
                    label={ __( labelMerge.padding ) }
                >
                    <BoxControl
                        __next40pxDefaultSize
                        label =  { <VayuBlocksDeviceControl label={__(labelMerge.padding)} classname='bold' /> }
                        onChange={(newValue) => handleDimensionChange('padding', newValue)}
                        values={ paddingValues }
                        sides={sides.padding}
                        inputProps={inputProps.padding}
                        splitOnAxis={splitOnAxis}
                        presetKey="vayu-blocks-spacing"
                        presets={presets}
                    />
                </ToolsPanelItem>
            }

            {dimensions.margin &&
                <ToolsPanelItem
                    hasValue={ () => !! marginValues }
                    label={ __( labelMerge.margin) }
                >
                    <BoxControl
                        __next40pxDefaultSize
                        label =  { <VayuBlocksDeviceControl label={__(labelMerge.margin)} classname='bold' /> }
                        onChange={(newValue) => handleDimensionChange('margin', newValue)}
                        values={ marginValues}
                        sides={sides.margin}
                        inputProps={inputProps.margin}
                        splitOnAxis={splitOnAxis}
                         presetKey="vayu-blocks-spacing"
                        presets={presets}
                    />
                </ToolsPanelItem>
            }
        </ToolsPanel>
)} 